import { ActionButton } from "./ActionButton";
import { RequestActionModal } from "./RequestActionModal";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { gql } from "./__generated__/gql";
import { useMutation } from "@apollo/client";

export const REQUEST_ORDER_UPDATE = gql(`
  mutation RequestOrderUpdate(
    $orderNumber: String!,
    $patientName: String!,
    $fromEmail: Boolean!,
    $token: String!
  ) {
    requestOrderUpdate(
      orderNumber: $orderNumber,
      patientName: $patientName,
      fromEmail: $fromEmail,
      token: $token
    )
  }
`);

interface Props {
  orderNumber: string;
  patientName: string | null | undefined;
  setRefreshTimeline: (arg: boolean) => void;
}

export function RequestOrderUpdate(props: Props) {
  const [requestOrderUpdate] = useMutation(REQUEST_ORDER_UPDATE, {
    fetchPolicy: "no-cache",
  });

  const submitOrderUpdateRequest = () => {
    if (props.patientName) {
      requestOrderUpdate({
        variables: {
          orderNumber: props.orderNumber,
          patientName: props.patientName,
          fromEmail: false,
          token: "",
        },
      });

      setTimeout(() => props.setRefreshTimeline(true), 1000);

      // temp workaround to get graphql mutation working with ActionButtons
      return Promise.resolve({
        ok: true,
        json: () => {
          return { ok: true };
        },
      });
    }
  };

  return (
    <ActionButton
      styleType="outline"
      fontAwesomeIcon={faBell}
      text="Request update"
      action={() => {}}
      childComponent={(setShowChildren: (show: boolean) => void) => {
        return (
          <RequestActionModal
            onDismiss={setShowChildren}
            onSubmit={submitOrderUpdateRequest}
            header={`Request Order Update: ${props.orderNumber}`}
          >
            <p className="tw-text-bold">
              A member of our team will check on the status of this order. We'll
              then let you know the current status by email &amp; fax.
            </p>
          </RequestActionModal>
        );
      }}
    />
  );
}
